import Immutable from "seamless-immutable";

const initialState = Immutable({});

const AwardReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default AwardReducer;
